<template>
  <TopNavbar v-bind:links="links"></TopNavbar>
  <div v-bind:style="'border-left: 20px solid ' + color">
    <div class="home-title d-flex" v-bind:style="'background-image: url(' + require('@/assets/'+ background) + ')'">
      <div class="home-title-div">
        <h1 class="d-flex align-self-center">{{title}}</h1>
        <h3 class="d-flex align-self-center">{{subtitle}}</h3>
        <p class="d-flex align-self-center"><b>{{scroll}}</b></p>
      </div>
    </div>
    <div class="home-row home-center d-flex">
      <p class="align-self-center" v-html="quote"></p>
    </div>
    <div class="home-row home-center d-flex">
      <p class="align-self-center" v-html="intro"></p>
    </div>
    <div class="home-center d-flex">
        <MenuButtons v-bind:links="links"></MenuButtons>
    </div>
  </div>
  <BottomNavbar v-bind:color="color"></BottomNavbar>
</template>

<script>

import TopNavbar from './components/TopNavbar.vue'
import MenuButtons from './components/MenuButtons.vue'
import BottomNavbar from './components/BottomNavbar.vue'

export default {
  name: 'HomePage1',
  inject:['links'],
  components: {
     TopNavbar,
     MenuButtons,
     BottomNavbar
  },
  mounted(){
    this.setColorScheme();
  },
  created(){
    this.setColorScheme();
  },
  data(){
    return{
      color:"#C41E3A",
      background:"home/splashbackground.jpg",
      title:"Global Madison",
      subtitle:"An Atlas",
      scroll:"Scroll to Continue",
      quote:"<i>It is a sense of place, an understanding of 'its character', which can only be constructed by linking that place to places beyond... What we need, it seems to me, is a global sense of the local, a global sense of place.</i><br><span style='margin-left:50%'>—Doreen Massey</span>",
      intro:"In this atlas, we will explore the social and physical landscapes of Madison, Wisconsin. In doing so, we will develop what the Geographer Doreen Massey called “a global sense of place”.<br><br>First, you will see how Madison, like any city, has been shaped by its <b>interdependencies</b> with other economies and ecologies around the world. Most case studies of globalization focus on megacities such as New York or Tokyo. But the landscape in Madison also bears the marks of various rounds of regional and global economic restructuring.<br><br>Second, by mapping these interdependencies, you will identify the relationship between global economic integration and rising <b>inequalities</b>. Madison occupies a relatively privileged position within global networks of production and trade. But Madison’s prosperity always has been bound together with the impoverishment of other people and places. Moreover, global interdependencies have often exacerbated social-economic inequalities within Madison.<br><br>Third, by grounding the global issues in the landscape that surrounds you, we hope to dispel the idea that globalization is something that happens “out there”, beyond our control. Ultimately, the world economy works the way it does because of decisions people make about what to buy, where to invest their money, what political causes to support. If those actions are not promoting the wellbeing of the community and the planet, we can think about <b>alternatives</b>. This atlas will prompt you to reflect on how your own everyday actions impact the lives of others―including those who may otherwise seem distant.<br><br><b>Begin your journey through Madison by choosing from one of the chapters below.</b>"
    }
  },
  methods:{
    setColorScheme(){
        if (document.querySelectorAll(".link")){
          document.querySelectorAll(".link").forEach(function(link){
            link.style.color = "black";
            link.style.backgroundColor = "rgba(0,0,0,0)";
          });   
        }
        if (document.querySelector(".home")){
          document.querySelector(".home").style.color = "white";
          document.querySelector(".home").style.backgroundColor = this.color;
        }
     }
  }
}
</script>

<style>
/*home title styles*/
    .home-title{
      height:100vh;
    }
    .home-title-div{
      margin:auto;
      background:rgba(255,255,255,0.8);
      padding:15px;

    }
    .home-title-div > h1{
      font-size:75px;
    }
    .home-title-div > h3{
      font-size:50px;
      margin:auto;
    }
    .home-title-div > p {
      text-align:left;
    }
    .home-title-div > p > b{
      font-size:20px;
      margin: auto;
      margin-top: 20px;
    }
/*home row styles*/
    .home-row{
      margin-top:20%;
      text-align:left;
    }
    
    @media screen and (min-width: 1200px) {
        .home-center{
            flex: 0 0 auto;
            margin-left:25%;
            width:50%;
        }
      }
    @media screen and (min-width: 720px) and (max-width: 1199px) {
        .home-center{
            flex: 0 0 auto;
            margin-left: 16.66666667%;
            width: 66.66666667%;
        }
    }
    @media screen and (min-width: 540px) and (max-width: 719px) {
        .home-center{
            flex: 0 0 auto;
            margin-left: 8.33333333%;
            width: 83.333333333%;
        }
    }
    @media screen and (max-width: 539px) {
        .home-center{
            width: 100%;
        }
    }
</style>
